export enum SectorType {
    MULTIPLIER = 'multiplier',
    BONUS_MAIN = 'bonusMain',
    BONUS_ALPHA = 'bonusAlpha',
    BONUS_BETA = 'bonusBeta',
    BUST = 'bust',
    RED = 'red',
    BLUE = 'blue',
    CHEST = 'chest',
}
